import React from 'react';
import { envIsCanada, envIsNormal } from '@/constants/constants';
import { envIsMexico } from '@/constants/constants';
import MexicoRegistrationForm from '@/features/authentication/registration/mexico/MexicoRegistrationForm';
import FastRegistrationForm from '@/features/authentication/registration/fast-registration/FastRegistrationForm';
import RegistrationIntroCanada from '@/features/authentication/registration/canada/RegistrationIntroCanada';
import { useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import RegistrationThailandForm from '@/features/authentication/registration/thailand/RegistrationThailandForm';

const Registration = () => {
  const locale = useSelector(selectLocale);

  if (envIsMexico()) {
    return <MexicoRegistrationForm />;
  } else if (envIsCanada()) {
    return <RegistrationIntroCanada />;
  } else if (envIsNormal() && locale === 'th') {
    return <RegistrationThailandForm />;
  } else {
    return <FastRegistrationForm />;
  }
};

export default Registration;
